var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8861_9317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z",
    fill: "#64BA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 34.8284L30.7079 47.1691C40.9287 44.4435 48.4997 35.1312 48.4997 24.0019C48.4997 23.7747 48.4997 23.5476 48.4997 23.3205L38.8088 14.3867L18.3672 34.8284Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1061 29.3725C26.166 30.4325 26.166 32.2495 25.1061 33.3094L22.9105 35.505C21.8505 36.565 20.0335 36.565 18.9736 35.505L9.35843 25.8142C8.29849 24.7542 8.29849 22.9372 9.35843 21.8773L11.554 19.6817C12.614 18.6217 14.431 18.6217 15.4909 19.6817L25.1061 29.3725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5097 12.6426C34.5696 11.5827 36.3867 11.5827 37.4466 12.6426L39.6422 14.8382C40.7021 15.8981 40.7021 17.7152 39.6422 18.7751L22.986 35.3555C21.9261 36.4155 20.1091 36.4155 19.0491 35.3555L16.8535 33.16C15.7936 32.1 15.7936 30.283 16.8535 29.223L33.5097 12.6426Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8861_9317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.23c68795263bcc91ed65e4c40588b007.svg";
export { ForwardRef as ReactComponent };